<template>
  <page>
    <template slot="content">
    <help-content :title="'ｽﾏﾎで計測した歩数はﾍﾙｽｹｱｱﾌﾟﾘと異なる日がある'">
      <template slot="content">
        <div class="text">
          １．WeRUN（スマホ計測）とヘルスケアアプリの<b>歩数カウントの仕組みが異なります</b>。<br><br>
          ヘルスケアアプリは連続で歩いた歩数をまとめてカウントしているため、例えば0時を跨いで歩いた場合、0時前の一部の歩数が翌日の時刻にカウントされてしまいます。<br><br>
          WeRUN（スマホ計測）は歩数を発生した時刻にカウントしていますので、当日の歩数が翌日にカウントされるようなことはありません。<br><br>
          普通にアプリをご利用いただき、歩数が異なる日があっても、一定期間の合計歩数は同じですので、ご安心ください。<br><br>
          ２．<b>アプリを削除して再インストール</b>した日の歩数は異なる可能性があります。<br><br>
          AppleWatch等他社製デバイスを利用する場合を除いて、計測方法を「スマホ」に指定することをおすすめします。
        </div>
        <img class="picture" src="../assets/images/q_and_a/H40.png">
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help40.vue